import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SharedModule } from '../shared/shared.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CdkTreeModule } from '@angular/cdk/tree';
import { RouterModule } from '@angular/router';
// Primeng modules
import { BlockableDivModule } from '../shared/components/blockable-div/blockable-div.module';
import { ScenariosComponent } from './components/scenarios/scenarios.component';
import { BlockUIModule } from 'primeng/blockui';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { TableModule } from 'primeng/table';
import { InputNumberModule } from 'primeng/inputnumber';
import { DevicesModule } from '../device/devices.module';
import { CalendarModule } from 'primeng/calendar';
import { BadgeModule } from 'primeng/badge';
import { SceneryTabGroupComponent } from './components/scenery-tab-group/scenery-tab-group.component';
import { TabViewModule } from 'primeng/tabview';
import { CalendarComponent } from './components/calendar/calendar.component';
import { CalendarsListComponent } from './components/calendars-list/calendars-list.component';
import { SchedulesListComponent } from './components/schedules-list/schedules-list.component';
import { ScenariosListComponent } from './components/scenarios-list/scenarios-list.component';
import { AccordionModule } from 'primeng/accordion';
import { SceneryComponent } from './components/scenery/scenery.component';
import { TagModule } from 'primeng/tag';
import { ExceptionCalendarComponent } from './components/exceptions-calendar/exceptions-calendar.component';
import { SceneryDialogComponent } from './components/scenery-dialog/scenery.dialog.component';
import { StepDialogComponent } from './components/step-dialog/step.dialog.component';
import { StepsModule } from 'primeng/steps';
import { DropdownModule } from 'primeng/dropdown';
import { RadioButtonModule } from 'primeng/radiobutton';
import { SliderModule } from 'primeng/slider';
import { ScheduleDialogComponent } from './components/schedule-dialog/schedule.dialog.component';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { FullCalendarModule } from '@fullcalendar/angular';
import { CheckboxModule } from 'primeng/checkbox';
import { ChipModule } from 'primeng/chip';
import { AvatarModule } from 'primeng/avatar';
import { AvatarGroupModule } from 'primeng/avatargroup';
import { ExceptionsCalendarDialogComponent } from './components/exceptions-calendar-dialog/exceptions-calendar.dialog.component';
import { ExceptionCalendarCardComponent } from './components/exceptions-calendar-card/exceptions-calendar-card.component';
import { StepperModule } from 'primeng/stepper';
import { ProgressSpinnerModule } from 'primeng/progressspinner';

@NgModule({
	declarations: [
		CalendarComponent,
		CalendarsListComponent,
		ExceptionCalendarCardComponent,
		ExceptionCalendarComponent,
		ExceptionsCalendarDialogComponent,
		ScenariosComponent,
		ScenariosListComponent,
		SceneryComponent,
		SceneryDialogComponent,
		SceneryTabGroupComponent,
		ScheduleDialogComponent,
		SchedulesListComponent,
		StepDialogComponent,
	],
	imports: [
		// PrimeNg modules
		AccordionModule,
		AutoCompleteModule,
		AvatarGroupModule,
		AvatarModule,
		BadgeModule,
		BlockableDivModule,
		BlockUIModule,
		ButtonModule,
		CalendarModule,
		CdkTreeModule,
		CheckboxModule,
		ChipModule,
		CommonModule,
		DevicesModule,
		DropdownModule,
		FormsModule,
		FullCalendarModule,
		InputNumberModule,
		InputTextModule,
		ProgressSpinnerModule,
		RadioButtonModule,
		ReactiveFormsModule,
		RouterModule,
		SharedModule,
		SliderModule,
		StepperModule,
		StepsModule,
		TableModule,
		TabViewModule,
		TagModule,
	],
	exports: [
		CalendarComponent,
		CalendarsListComponent,
		ExceptionCalendarComponent,
		ExceptionsCalendarDialogComponent,
		ScenariosComponent,
		ScenariosListComponent,
		SceneryComponent,
		SceneryDialogComponent,
		SceneryTabGroupComponent,
		SchedulesListComponent,
		StepDialogComponent,
	]
})
export class ScenariosModule { }
